function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { ConfirmInvitationRequest, CreateInvitationRequest, DeleteInvitationRequest, GetDeactivatedUsersRequest, GetInvitedUsersForLogisticsPartyRequest, GetRequestedUserProfileInfoRequest, GetUserProfileInfoRequest, GetUsersForLogisticsPartyRequest, ResendInvitationRequest, UpdateUserProfileInfoRequest, User } from "@amzn/coral_com-amazon-passportusermanagementservice";
import passportUserManagementServiceClient from "../../clients/PassportUserManagementServiceClient";
import envHelper from "../../config/env";
import isSiteExternal from "../../utils/isSiteExternal";
var isExternal = isSiteExternal();
export function getUserProfileInfo() {
    var getUserProfileInfoInput = GetUserProfileInfoRequest.clone({});
    return passportUserManagementServiceClient.getUserProfileInfo(getUserProfileInfoInput);
}
export function updateUserProfileInfo(param) {
    var userIdentifier = param.userIdentifier, designation = param.designation, email = param.email, fullName = param.fullName, textPhoneNumber = param.textPhoneNumber, auditVersion = param.auditVersion, defaultLocale = param.defaultLocale, monsSelectLocale = param.monsSelectLocale;
    var user = User.clone(_objectSpread({
        userIdentifier: userIdentifier,
        designation: designation,
        email: email,
        fullName: fullName,
        textPhoneNumber: textPhoneNumber,
        auditVersion: auditVersion
    }, defaultLocale ? {
        defaultLocale: defaultLocale
    } : {}));
    var updateUserProfileInfoRequest = UpdateUserProfileInfoRequest.clone(_objectSpread({
        user: user
    }, ({
        monsSelectLocale: monsSelectLocale
    } || {})));
    return passportUserManagementServiceClient.updateUserProfileInfo(updateUserProfileInfoRequest);
}
export function acceptInvitation(request) {
    return passportUserManagementServiceClient.acceptInvitation(request);
}
export function createInvitation(param) {
    var invitationChannelInfo = param.invitationChannelInfo, locale = param.locale, requestedPermissionsList = param.requestedPermissionsList, logisticsPartyId = param.logisticsPartyId;
    return passportUserManagementServiceClient.createInvitation(CreateInvitationRequest.clone(_objectSpread({
        invitationChannelInfo: invitationChannelInfo,
        locale: locale,
        requestedPermissionsList: requestedPermissionsList
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
export function resendInvitation(param) {
    var invitationId = param.invitationId, logisticsPartyId = param.logisticsPartyId;
    return passportUserManagementServiceClient.resendInvitation(ResendInvitationRequest.clone(_objectSpread({
        invitationId: invitationId
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
export function deleteInvitation(param) {
    var invitationId = param.invitationId, logisticsPartyId = param.logisticsPartyId;
    return passportUserManagementServiceClient.deleteInvitation(DeleteInvitationRequest.clone(_objectSpread({
        invitationId: invitationId
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
export function confirmInvitation(param) {
    var invitationId = param.invitationId, logisticsPartyId = param.logisticsPartyId;
    return passportUserManagementServiceClient.confirmInvitation(ConfirmInvitationRequest.clone(_objectSpread({
        invitationId: invitationId
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
export function getUsersForLogisticsParty(param) {
    var logisticsPartyId = param.logisticsPartyId;
    return passportUserManagementServiceClient.getUsersForLogisticsParty(GetUsersForLogisticsPartyRequest.clone(_objectSpread({
        fetchInternalUsers: !envHelper.isProd()
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
export function getInvitedUsersForLogisticsParty(param) {
    var logisticsPartyId = param.logisticsPartyId;
    return passportUserManagementServiceClient.getInvitedUsersForLogisticsParty(GetInvitedUsersForLogisticsPartyRequest.clone(_objectSpread({}, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
export function deactivateUser(deactivateUserRequest) {
    return passportUserManagementServiceClient.deactivateUser(deactivateUserRequest);
}
export function getDeactivatedUsers(param) {
    var logisticsPartyId = param.logisticsPartyId;
    return passportUserManagementServiceClient.getDeactivatedUsers(GetDeactivatedUsersRequest.clone(_objectSpread({
        fetchInternalUsers: !envHelper.isProd()
    }, !isExternal && logisticsPartyId ? {
        logisticsPartyId: logisticsPartyId
    } : {})));
}
export function fetchRequestedUserDetails(param) {
    var requestedUserId = param.requestedUserId;
    return passportUserManagementServiceClient.getRequestedUserProfileInfo(GetRequestedUserProfileInfoRequest.clone({
        requestedUserId: requestedUserId
    }));
}

//# sourceMappingURL=index.js.map